import { Badge } from "./ui/badge";
import { getPromotionalPricing, PROMO_ACTIVE, PROMO_BADGE_TEXT } from "../utils/promoUtils";

// Promotional Price Display Component
// Shows original price struck through, sale price, and savings badge
export const PromoPriceDisplay = ({ 
  price, 
  size = "default", // "default" | "small" | "large"
  showBadge = true,
  className = "" 
}) => {
  if (!PROMO_ACTIVE) {
    // If promo is not active, show regular price
    return (
      <div className={`font-heading font-bold ${size === "large" ? "text-2xl" : size === "small" ? "text-lg" : "text-xl"} text-brand ${className}`}>
        ${price}
      </div>
    );
  }

  const promo = getPromotionalPricing(price);
  
  const sizeClasses = {
    small: {
      container: "text-right",
      original: "text-xs",
      sale: "text-lg",
      savings: "text-sm font-bold",
      badge: "text-[10px] px-1.5 py-0.5"
    },
    default: {
      container: "text-right",
      original: "text-sm",
      sale: "text-xl",
      savings: "text-base font-bold",
      badge: "text-xs px-2 py-0.5"
    },
    large: {
      container: "text-right",
      original: "text-base",
      sale: "text-2xl",
      savings: "text-lg font-bold",
      badge: "text-xs px-2 py-1"
    }
  };

  const styles = sizeClasses[size];

  return (
    <div className={`${styles.container} ${className}`}>
      {showBadge && (
        <Badge className={`bg-red-500 text-white ${styles.badge} mb-1 inline-block`}>
          {PROMO_BADGE_TEXT}
        </Badge>
      )}
      <div className="flex items-center justify-end gap-2">
        <span className={`${styles.original} text-muted-foreground line-through`}>
          ${promo.originalPrice}
        </span>
        <span className={`font-heading font-bold ${styles.sale} text-brand`}>
          ${promo.salePrice}
        </span>
      </div>
      <div className={`${styles.savings} text-green-600 mt-0.5`}>
        Save ${promo.savings}
      </div>
    </div>
  );
};

// Inline price for format selection labels
export const PromoFormatPrice = ({ price }) => {
  if (!PROMO_ACTIVE) {
    return <span className="font-heading font-bold text-brand">${price}</span>;
  }

  const promo = getPromotionalPricing(price);
  
  return (
    <div className="text-right">
      <span className="text-xs text-muted-foreground line-through mr-1">${promo.originalPrice}</span>
      <span className="font-heading font-bold text-brand">${promo.salePrice}</span>
      <div className="text-xs font-semibold text-green-600">Save ${promo.savings}</div>
    </div>
  );
};

// Small inline savings text for course cards
export const PromoInlinePrice = ({ price }) => {
  if (!PROMO_ACTIVE) {
    return <span className="ml-1 text-xs opacity-75">${price}</span>;
  }

  const promo = getPromotionalPricing(price);
  
  return (
    <>
      <span className="ml-1 text-xs line-through opacity-50">${promo.originalPrice}</span>
      <span className="ml-1 text-xs font-medium text-green-600">${promo.salePrice}</span>
    </>
  );
};

export default PromoPriceDisplay;
